import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-change-modal',
  templateUrl: './change-modal.component.html',
  styleUrls: ['./change-modal.component.css']
})

export class ChangeModalComponent implements OnInit {

  public id: string;
  private value: number = null;

  public disabledBtn = false;
  public successInfo = false;
  public errorInfo = false;
  action;
  title = ''
  obj;

  constructor(public activeModal: NgbActiveModal,
    private adminService: AdminService) {
  }

  ngOnInit() {
    if (!this.obj) {
      this.obj = {
        learningSpeed: 1,
        amountPossibleRedirections: 10,
        postponedSheetDetection: 10,
        amountDaysReviewSuggestionLists: 5,
        amountDaysPassStandard: 30,
        amountDaysPassStandardForAll: 7,
        costPunishmentsAwards: 1,
        amountDaysPunishmentExpiredTask: 2,
        costSuggestionsList: 1,
        costLearning: 1,
        cosBeingLate: 1,
        bonusCorrectAnswers: 1,
        bonusUnCorrectAnswers: 1,
        lowLevelOfCorrectQuestion: 2.8,
        percentageOfWagesPerLevel: 1,
        vacationAmount: 24,
        meritBall: 25,
        holidayCoefficient: 1,
        amountOfPossiblePostpones: 2
      }
    }
  }

  setValue(value) {
      this.value = value;
  }

  changeFour(value) {
      if(value < 0) {
        this.value = 0;
      }  
      if(value > 100) {
        this.value = 100;
      }
  }

  renameGroup() {
    if (this.action == 'learningSpeed') {
      this.obj.learningSpeed = this.value;
    }
    if (this.action == 'amountPossibleRedirections') {
      this.obj.amountPossibleRedirections = this.value;
    }
    if (this.action == 'postponedSheetDetection') {
      this.obj.postponedSheetDetection = this.value;
    }
    if (this.action == 'amountDaysReviewSuggestionLists') {
      this.obj.amountDaysReviewSuggestionLists = this.value;
    }
    if (this.action == 'amountDaysPassStandard') {
      this.obj.amountDaysPassStandard = this.value;
    }
    if (this.action == 'amountDaysPassStandardForAll') {
      this.obj.amountDaysPassStandardForAll = this.value;
    }
    if (this.action == 'costPunishmentsAwards') {
      this.obj.costPunishmentsAwards = this.value;
    }
    if (this.action == 'amountDaysPunishmentExpiredTask') {
      this.obj.amountDaysPunishmentExpiredTask = this.value;
    }
    if (this.action == 'costSuggestionsList') {
      this.obj.costSuggestionsList = this.value;
    }
    if (this.action == 'costLearning') {
      this.obj.costLearning = this.value;
    }
    if (this.action == 'cosBeingLate') {
      this.obj.cosBeingLate = this.value;
    }
    if (this.action == 'bonusCorrectAnswers') {
      this.obj.bonusCorrectAnswers = this.value;
    }
    if (this.action == 'bonusUnCorrectAnswers') {
      this.obj.bonusUnCorrectAnswers = this.value;
    }
    if (this.action == 'lowLevelOfCorrectQuestion') {
      this.obj.lowLevelOfCorrectQuestion = this.value;
    }
    if (this.action == 'percentageOfWagesPerLevel') {
      this.obj.percentageOfWagesPerLevel = this.value;
    }
    if (this.action == 'vacationAmount') {
      this.obj.vacationAmount = this.value;
    }
    if (this.action == 'meritBall') {
      this.obj.meritBall = this.value;
    }
    if (this.action == 'holidayCoefficient') {
      this.obj.holidayCoefficient = this.value;
    }
    if (this.action == 'amountOfPossiblePostpones') {
      this.obj.amountOfPossiblePostpones = this.value;
    }
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;
    this.adminService.changeModalSettings(this.obj).subscribe(
      (res: any) => {
        this.successInfo = true;
        this.errorInfo = false;
        this.disabledBtn = false;
        this.activeModal.close('ok');
      },
      () => {
        this.errorInfo = true;
      }
    );
  }

  disableBtnValidation() {
    return this.value === null;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-user-report/change-modal/change-modal.component.ts